/**
 * YK Visit Module Models
 * Camp_Type: "YV", App_Id: 5
 * All DTOs mirror the C# backend: RetreatRegistrationDetailDTO, GetVisitsRecordDTO, RetreatRegistrationDTO
 */

/**
 * @typedef {Object} YkVisitCenter
 * @property {number} center_Id
 * @property {string} center_Name
 * @property {string} center_Logo_URL
 * @property {string} center_desc
 * @property {number} organization_Id
 * @property {number} app_Id
 */

/**
 * @typedef {Object} YkVisitCamp
 * @property {number} camp_Id
 * @property {number} center_Id
 * @property {string} camp_Name
 * @property {string} camp_Description
 * @property {number} camp_Fee
 * @property {string} camp_Date_From
 * @property {string} camp_Date_To
 * @property {string} camp_Image_Url
 * @property {string} camp_Type  // "YV"
 * @property {number} app_Id     // 5
 * @property {number} organization_Id
 * @property {string} country_Desc
 */

/**
 * @typedef {Object} YkVisitStudent
 * @property {number} student_Id
 * @property {string} student_First_Name
 * @property {string} student_Last_Name
 * @property {string} student_Date_Of_Birth
 * @property {string} student_Gender
 * @property {string} student_Email
 * @property {string} student_Phone
 * @property {number} user_Id
 */

/**
 * @typedef {Object} VisitDateRow
 * @property {string} start_Date       // ISO string
 * @property {string} end_Date         // ISO string
 * @property {string} is_Accommodation_Needed  // "Y" | "N"
 * @property {string} is_Transport             // "Y" | "N"
 */

/**
 * @typedef {Object} RetreatRegistrationDetailDTO
 * @property {number} retreat_Registration_Details_Id
 * @property {number} retreat_Registration_Id
 * @property {number} student_Id
 * @property {number} camp_Id
 * @property {string} start_Date
 * @property {string} end_Date
 * @property {string} is_Accommodation_Needed
 * @property {string} is_Transport
 * @property {number} registration_Fee
 * @property {number} accommodation_Fees
 * @property {number} visits
 * @property {number} no_Of_Days
 * @property {string} status
 * @property {string} createdBy
 * @property {string} created
 */

/**
 * @typedef {Object} GetVisitsRecordDTO
 * @property {number} id
 * @property {number} retreat_Registration_Id
 * @property {number} retreat_Registration_Details_Id
 * @property {string} start_Date
 * @property {string} end_Date
 * @property {string} is_Accommodation_Needed
 * @property {string} is_Transport
 * @property {number} registration_Fee
 * @property {number} accommodation_Fees
 */

/**
 * @typedef {Object} RetreatRegistrationDTO
 * @property {number} retreat_Registration_Id
 * @property {number} student_Id
 * @property {number} camp_Id
 * @property {number} user_Id
 * @property {string} status
 * @property {string} createdBy
 * @property {string} created
 * @property {RetreatRegistrationDetailDTO[]} retreatRegistrations
 */

/**
 * @typedef {Object} VisitCalculation
 * @property {number} registration_Fee
 * @property {number} accommodation_Fees
 * @property {number} total_Fee
 * @property {number} amount_Paid
 * @property {number} net_To_Pay
 */

/**
 * @typedef {Object} PaymentDetails
 * @property {string} paymentType   // "CreditCard" | "ACH"
 * @property {string} cardNumber
 * @property {string} expiryDate    // MM/YY
 * @property {string} cvv
 * @property {string} cardholderName
 * @property {string} accountHolderName
 * @property {string} routingNumber
 * @property {string} accountNumber
 * @property {string} accountType   // "checking" | "savings"
 * @property {string} bankName
 * @property {number} amount
 */

export const CAMP_TYPE_VISIT = 'YV';
export const APP_ID_VISIT = 5;

export const DEFAULT_VISIT_DATE_ROW = {
  start_Date: '',
  end_Date: '',
  is_Accommodation_Needed: 'N',
  is_Transport: 'N',
};
